import { render, staticRenderFns } from "./CardRating.vue?vue&type=template&id=2b59db15&scoped=true&"
import script from "./CardRating.vue?vue&type=script&lang=js&"
export * from "./CardRating.vue?vue&type=script&lang=js&"
import style0 from "./CardRating.vue?vue&type=style&index=0&id=2b59db15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b59db15",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
